import { supabase } from "./supabase";

export interface DossierParametres {
  tvaActive: boolean;
  tauxTva: number;
  anneeExercice: number;
}

/** Récupère les paramètres d'un dossier */
export async function fetchParametres(dossierId: string): Promise<DossierParametres> {
  const { data, error } = await supabase
    .from("dossiers")
    .select("tva_active, taux_tva, annee_exercice, assujetti_tva, taux_tva_defaut")
    .eq("id", dossierId)
    .single();

  if (error) throw error;
  const annee = new Date().getFullYear();
  return {
    tvaActive: data?.assujetti_tva ?? data?.tva_active ?? false,
    tauxTva: Number(data?.taux_tva_defaut ?? data?.taux_tva ?? 18),
    anneeExercice: data?.annee_exercice ? Number(data.annee_exercice) : annee,
  };
}

/** Met à jour les paramètres d'un dossier */
export async function updateParametres(
  dossierId: string,
  p: DossierParametres
): Promise<void> {
  const { error } = await supabase
    .from("dossiers")
    .update({
      tva_active: p.tvaActive,
      taux_tva: p.tauxTva,
      annee_exercice: p.anneeExercice,
      assujetti_tva: p.tvaActive,
      taux_tva_defaut: p.tauxTva,
    })
    .eq("id", dossierId);

  if (error) throw error;
}
